import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import './Navbar.css';

const Navbar = ({ isMenuOpen, setIsMenuOpen }) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);

        // Prevent scrolling when menu is open
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.style.overflow = 'unset'; // Cleanup on component unmount
        };
    }, [isMenuOpen]);

    const navItems = [
        { name: 'Intro', id: 'introduction' },
        { name: 'Case Status', id: 'case-status' },
        { name: 'Summary', id: 'case-summary' },
        { name: 'Strategy', id: 'strategy' },
        { name: 'Action Plan', id: 'action-plan' },
        { name: 'Contingency', id: 'contingency-plan' },
    ];

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false); // Close menu on navigation
    };

    return (
        <motion.nav 
            className={`navbar ${scrolled ? 'scrolled' : ''}`}
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
            <div className="navbar-content">
                <div className="logo">§</div>

                {/* Desktop Navigation */}
                <ol className="desktop-nav-links">
                    {navItems.map((item, index) => (
                        <motion.li key={index} whileHover={{ y: -3 }}>
                            <button onClick={() => scrollToSection(item.id)}>{item.name}</button>
                        </motion.li>
                    ))}
                </ol>

                {/* Hamburger Menu Icon */}
                <div className="hamburger-menu">
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        {isMenuOpen ? <FiX /> : <FiMenu />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Panel */}
            <aside className={`mobile-nav-panel ${isMenuOpen ? 'open' : ''}`}>
                <nav>
                    <ol>
                        {navItems.map((item, index) => (
                             <li key={index} style={{ animationDelay: `${100 + index * 50}ms`}}>
                                <button onClick={() => scrollToSection(item.id)}>{item.name}</button>
                            </li>
                        ))}
                    </ol>
                </nav>
            </aside>
        </motion.nav>
    );
};

export default Navbar;